module.exports = __webpack_public_path__ + "img/phone.32a41e91.svg";